import React, { useState } from "react";
import { Link } from "react-router";
import { useSelector } from "react-redux";
import { footerCmsData } from "@/redux/cms/cmsSelectors";
import { markInternalNavigation } from "@/utils/attributionCapture";
import "./Footer.css";

const OtherLinkFooter = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const cmsData = useSelector(footerCmsData);

  const routePaths = {
    homeAuctionsNearYou: "/real-estate-auctions-near-me",
    texasAuctions: "/tx/auctions",
    floridaAuctions: "/fl/auctions",
    georgiaAuctions: "/ga/auctions",
    californiaAuctions: "/ca/auctions",
    illinoisAuctions: "/il/auctions",
    newYorkAuctions: "/ny/auctions",
    newJerseyAuctions: "/nj/auctions",
    bankOwnedHomesNearYou: "/bank-owned-near-me",
    bankOwnedHomesInTexas: "/tx/bank-owned",
    bankOwnedHomesInFlorida: "/fl/bank-owned",
    bankOwnedHomesInGeorgia: "/ga/bank-owned",
    bankOwnedHomesInCalifornia: "/ca/bank-owned",
    bankOwnedHomesInIllinois: "/il/bank-owned",
    bankOwnedHomesInNewYork: "/ny/bank-owned",
    bankOwnedHomesInNewJersey: "/nj/bank-owned",
    foreclosuresInTexas: "/tx/foreclosures",
    foreclosuresInFlorida: "/fl/foreclosures",
    foreclosuresInCalifornia:"/ca/foreclosures",
    foreclosuresInGeorgia: "/ga/foreclosures",
foreclosuresInIllinois:"/il/foreclosures",
foreclosuresInNewYork:"/ny/foreclosures",
foreclosuresInNewJersey:"/nj/foreclosures",
    signatureHomesNearYou: "/signature-properties-near-me",
    signatureHomesInFlorida: "/fl/auctions?sid=signature-seller",
    signatureHomesInTexas: "/tx/auctions?sid=signature-seller",
    signatureHomesInCalifornia: "/ca/auctions?sid=signature-seller",
    signatureHomesInGeorgia: "/ga/auctions?sid=signature-seller",
    signatureHomesInIllinois: "/il/auctions?sid=signature-seller",
    signatureHomesInNewYork: "/ny/auctions?sid=signature-seller",
    signatureHomesInNewJersey: "/nj/auctions?sid=signature-seller",
    commercialPropertiesInFlorida: "/fl/auctions?category=commercial",
    commercialPropertiesInTexas: "/tx/auctions?category=commercial",
    commercialPropertiesInCalifornia: "/ca/auctions?category=commercial",
    commercialPropertiesInGeorgia: "/ga/auctions?category=commercial",
    commercialPropertiesInIllinois: "/il/auctions?category=commercial",
    commercialPropertiesInNewYork: "/ny/auctions?category=commercial",
    commercialPropertiesInNewJersey: "/nj/auctions?category=commercial",
  };

  const toggleView = (key) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const renderSection = (sectionKey, data) => {
    if (!data) return null;

    const links = Array.isArray(data?.links) ? data.links : [];
    const sectionHeader = data?.updatedHeader || data?.header;

    if (!sectionHeader || links.length === 0) return null;

    return (
      <div
        key={sectionKey}
        id={`${sectionKey}-section`}
        className="col-md col-md-4 col-lg  mb-3 pt-5"
      >
        <h3
          id={`${sectionKey}-header`}
          className="footer-header-other mb-3"
          tabIndex="0"
        >
          {sectionHeader}
        </h3>

        {/* Desktop View */}
        <div id={`${sectionKey}-desktop`} className="d-lg-block d-none">
          <ul className="list-unstyled">
            {links
              .slice(0, expandedSections[sectionKey] ? links.length : 3)
              .map((link, index) => {
                const linkId = link
                  ?.trim()
                  ?.split(/\s+/)
                  .map((word, idx) =>
                    idx === 0
                      ? word.toLowerCase()
                      : word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                  )
                  .join("");
                const route = routePaths[linkId];

                return (
                  <li key={`${sectionKey}-${index}`} className="mb-2">
                    <Link
                      id={`${linkId}-desktop`}
                      to={route || "#"}
                      onClick={() => { markInternalNavigation(); }}
                      className="text-decoration-none footer-link-home"
                    >
                      {link}
                    </Link>
                  </li>
                );
              })}

            {links.length > 3 && (
              <li className="show-more pt-1">
                <span
                  id={`${sectionKey}-show-more-btn`}
                  onClick={() => toggleView(sectionKey)}
                  role="button"
                  tabIndex="0"
                  aria-label="View more items"
                  className="show-more"
                >
                  {expandedSections[sectionKey] ? "Show Less" : "Show More"}
                </span>
                <img
                  src="/assets/images/home/Footer_ShowMore.svg"
                  alt="show-more"
                  style={{
                    margin: "0px 8px",
                    transform: expandedSections[sectionKey]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </li>
            )}
          </ul>
        </div>

           {/* Mid size screen View */}
        <div id={`${sectionKey}-midsize`} className="d-lg-none d-md-block d-none">
          <ul className="list-unstyled">
            {links
              .slice(0, expandedSections[sectionKey] ? links.length : 4)
              .map((link, index) => {
                const linkId = link
                  ?.trim()
                  ?.split(/\s+/)
                  .map((word, idx) =>
                    idx === 0
                      ? word.toLowerCase()
                      : word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                  )
                  .join("");
                const route = routePaths[linkId];

                return (
                  <li key={`${sectionKey}-${index}`} className="mb-2">
                    <Link
                      id={`${linkId}-midsize`}
                      to={route || "#"}
                      onClick={() => { markInternalNavigation(); }}
                      className="text-decoration-none footer-link-home"
                    >
                      {link}
                    </Link>
                  </li>
                );
              })}

            {links.length > 4 && (
              <li className="show-more pt-1">
                <span
                  id={`${sectionKey}-show-more-btn`}
                  onClick={() => toggleView(sectionKey)}
                  role="button"
                  tabIndex="0"
                  aria-label="View more items"
                  className="show-more"
                >
                  {expandedSections[sectionKey] ? "Show Less" : "Show More"}
                </span>
                <img
                  src="/assets/images/home/Footer_ShowMore.svg"
                  alt="show-more"
                  style={{
                    margin: "0px 8px",
                    transform: expandedSections[sectionKey]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </li>
            )}
          </ul>
        </div>

        {/* Mobile View */}
        <div id={`${sectionKey}-mobile`} className="d-md-none">
          <div className="d-flex flex-column">
            {links
              .slice(0, expandedSections[sectionKey] ? links.length : 3)
              .map((link, index) => {
                const linkId = link
                  ?.trim()
                  ?.split(/\s+/)
                  .map((word, idx) =>
                    idx === 0
                      ? word.toLowerCase()
                      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join("");
                const route = routePaths[linkId];

                return (
                  <Link
                    key={`${sectionKey}-mobile-${index}`}
                    id={`${linkId}-mobile`}
                    to={route || "#"}
                    onClick={() => { markInternalNavigation(); }}
                    className="link-text mb-2"
                  >
                    {link}
                  </Link>
                );
              })}
          </div>

          {links.length > 3 && (
            <span
              id={`${sectionKey}-show-more-mobile-btn`}
              className="show-more pt-1 ml5"
              onClick={() => toggleView(sectionKey)}
              role="button"
              tabIndex="0"
              aria-label="View more items"
            >
              {expandedSections[sectionKey] ? " Show Less" : " Show More"}
              <img
                src="/assets/images/home/Footer_ShowMore.svg"
                alt="show-more"
                style={{
                  margin: "0px 8px",
                  transform: expandedSections[sectionKey]
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <section
      id="other-links-footer-section"
      className="py-4"
      // style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container-fluid  px-5 ">
        <div className="row footer-line-top ">
          {renderSection("homeAuctions", cmsData?.homeAuctions)}
          {renderSection("bankOwnedHomes", cmsData?.bankOwnedHomes)}
          {renderSection("foreclosures", cmsData?.foreclosures)}
          {renderSection("signatureHomes", cmsData?.signatureHomes)}
          {renderSection("commercialProperties", cmsData?.commericalProperties)}
        </div>
      </div>
    </section>
  );
};

export default OtherLinkFooter;
